import { render } from "./PageProductGroupHistory.vue?vue&type=template&id=51092ca0&scoped=true"
import script from "./PageProductGroupHistory.vue?vue&type=script&lang=js"
export * from "./PageProductGroupHistory.vue?vue&type=script&lang=js"

import "./PageProductGroupHistory.vue?vue&type=style&index=0&id=51092ca0&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51092ca0"]])

export default __exports__